"use client";

/*

  return viewport dimensions

*/

import { useCallback, useState, useLayoutEffect } from "react";
import { debounce } from "../../delay";
import type { TBreakpoints, IViewportReturnProps } from "@hsr/types";

export const useViewport = (delay = 250): IViewportReturnProps => {
  const [windowSize, setWindowSize] = useState<IViewportReturnProps>({
    width: 0,
    height: 0,
    tailwindBreakpoint: "mobile",
    screenWidth: 0
  });

  const handleResize = useCallback(() => {
    const breakpoint = getBreakpoint(window.innerWidth);

    setWindowSize({
      width: breakpoint !== "mobile" ? window.innerWidth : window.screen.width,
      height: window.innerHeight,
      tailwindBreakpoint: breakpoint,
      screenWidth: window.innerWidth
    });
  }, []);

  useLayoutEffect(() => {
    // Debounce to avoid the function fire multiple times
    const handleResizeDebounced = debounce(handleResize, delay);

    window.addEventListener("resize", handleResizeDebounced);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResizeDebounced);
    };
  }, [delay, handleResize]);

  return windowSize;
};

const getBreakpoint = (innerWidth: number): TBreakpoints => {
  let breakpoint = "mobile";

  if (innerWidth >= 640) breakpoint = "sm";
  if (innerWidth >= 768) breakpoint = "md";
  if (innerWidth >= 1024) breakpoint = "lg";
  if (innerWidth >= 1280) breakpoint = "xl";
  if (innerWidth >= 1536) breakpoint = "2xl";

  return breakpoint as TBreakpoints;
};
